<template>
  <div class="dbox">
    <b-alert :show="alertDesc!==''" variant="warning">{{alertDesc}}</b-alert>
    <!-- input -->
    <div class="box">
      <div class="header" @click="switchmenu('zip')">
        <h3 class="h3-title">
          <icon v-show="step === 'zip'" name="chevron-down" class="h3-icon"/>
          <icon v-show="step !== 'zip'" name="chevron-right" class="h3-icon"/>
          Enter SCF Codes (up to 25)
        </h3>
      </div>
      <div v-show="step === 'zip'" class="zipr-box ">
        <div class="zip-code-box">
          <div class="zip-input-box" v-for="(item,index) in zips">
            <b-input class="zip-input" :id="'zip'+index"
                     maxlength="3"
                     v-model="item.zip"
                     @input="nextInput(index,$event)"
                     @change="$store.commit('geo/saveKey', ['geoUnAdd', 'zip'])">
            </b-input>
          </div>
        </div>
        <b-btn variant="primary"
               :disabled="nextDisabled"
               style="display: block"
               data-test="geo-scf-add"
               @click="addZip">Add
        </b-btn>
      </div>
    </div>
    <!-- range -->
    <div class="box">
      <div class="header" @click="switchmenu('rangezip')">
        <h3 class="h3-title">
          <icon v-show="step === 'rangezip'" name="chevron-down" class="h3-icon"/>
          <icon v-show="step !== 'rangezip'" name="chevron-right" class="h3-icon"/>
          Enter SCF Code Range
        </h3>
      </div>
      <div v-show="step=='rangezip'" class="zip-content-box">
        <div class="zipbox">
          <b-input v-model="zipFrom"
                   maxlength="3"
                   @input="fromChange($event)"
                   class="zip-inputr"></b-input>
          <span class="to">to</span>
          <b-input v-model="zipTo"
                   id="zipto"
                   maxlength="3"
                   class="zip-inputr zip-to"></b-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {
      geoType: {
        type: Number
      },
      isGo: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        zips: [],
        zipDesc: '',
        zipType: 1,
        zipFrom: '',
        zipTo: '',
        step: 'zip',
        nextDisabled: false,
        alertDesc: '',
        needCb: false
      }
    },
    computed: {
      realGeoType () {
        return this.$store.state.config.geoTypes.SCFCode
      },
      zipTypes () {
        return this.$store.state.geo.zipTypes
      },
      // TODO@Pony need update
      geoItems () {
        return this.$store.getters['order/geoItems']
      }
    },
    watch: {
      isGo (val) {
        if (val) {
          this.next()
        }
      }
    },
    created () {
      // add zips
      for (let i = 0; i < 25; i++) {
        this.zips.push({zip: ''})
      }
    },
    methods: {
      next () {
        if (this.step === 'zip') {
          this.addZip()
        } else if (this.step === 'rangezip') {
          this.rangeaddZip()
        } else {
          this.pasteaddZip()
        }
      },
      addZip () {
        // read zip from input
        this.lock()
        let zipInputs = JSON.parse(JSON.stringify(this.zips))
        let zips = []
        for (let zip of zipInputs) {
          if (zip.zip.length === 3) {
            zips.push(zip.zip)
          }
        }

        if (zips.length === 0 && this.geoItems.length > 0 && this.isGo) {
          this.unlock()
          return
        } else if (zips.length === 0) {
          this.alertDesc = 'Please input at least one SCF Code.'
          this.unlock()
          return
        }

        // check zip
        this.$http.post('PlaceOrder.aspx/GetZipsByScf', {
          zipType: 1,
          zips: zips
        }).then(resp => {
          // add zip to order
          let respZips = resp.body.d.DataSource
          if (respZips.length !== zips.length) {
            this.alertDesc = 'Please enter the correct ZIP codes. Invalid or duplicate entries have been removed.'
            this.$emit('update:isGo', false)
          }
          if (respZips.length === 0 && this.geoItems.lenght === 0) {
            this.alertDesc = 'Please input at least one valid zip. Invalid or duplicate entries have been removed.'
            this.$emit('update:isGo', false)
          }

          for (let zip of respZips) {
            this.$store.commit('order/addGeo', {
              GeoKeyCode: zip,
              GeoKeyDesc: zip,
              GeoType: 8
            })
          }
          this.unlock()
        }, resp => {
          this.unlock()
        })
        for (let item of this.zips) {
          item.zip = ''
        }
      },
      selectGeoType () {
        if (this.order.GeoType !== this.geoType.code) {

        }
      },
      validZip (zips) {
        this.$http.post('PlaceOrder.aspx/GetZipsByScf', {
          zipType: 0,
          zips: zips
        }).then(resp => {
          // add zip to order
          let zips = resp.body.d.DataSource
          if (zips.length === 0) {
            this.alertDesc = 'Please input at least one valid zip. Invalid or duplicate entries have been removed.'
            this.unlock()
            return
          }
          for (let zip of zips) {
            this.$store.commit('order/addGeo', {
              GeoKeyCode: zip,
              GeoKeyDesc: zip,
              GeoType: 8
            })
          }
          this.zipFrom = ''
          this.zipTo = ''
          this.unlock()
        }, resp => {
          this.unlock()
        })
      },
      rangeaddZip () {
        this.lock()
        if ((this.zipFrom === '' || this.zipTo === '') && this.geoItems.length > 0 && this.isGo) {
          this.unlock()
          return
        } else if ((this.zipFrom === '' || this.zipTo === '')) {
          this.alertDesc = 'Please input SCF Code.'
          this.unlock()
          return
        }

        this.$http.post('PlaceOrder.aspx/GetSCFcodesBySCFRange', {
          fromSCF: this.zipFrom,
          toSCF: this.zipTo,
          maxLength: 500
        }).then(resp => {
          this.validZip(resp.body.d.DataSource)
        }, resp => {
          this.unlock()
        })
      },
      switchmenu (val) {
        if (this.step !== val) {
          this.step = val
        } else {
          if (this.step === 'zip') {
            this.step = 'rangezip'
          } else {
            this.step = 'zip'
          }
        }
      },
      lock () {
        this.$store.dispatch('order/changeGeoType', this.geoType)
        this.nextDisabled = true
        this.alertDesc = ''
      },
      unlock () {
        this.nextDisabled = false
        this.$emit('update:isGo', false)
        if (this.isGo & this.alertDesc === '') {
          this.$store.dispatch('geo/next', true)
        }
      },
      fromChange (v) {
        if (v.length === 3) {
          document.getElementById('zipto').focus()
        }
      },
      nextInput (index, v) {
        if (v.length === 3 && index < 24) {
          document.getElementById('zip' + (index + 1)).focus()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .dbox {
    width: 100%;
  }

  .zip-input-box {
    display: inline-block;
    margin: 0;
    padding-left: 8px;
    padding-right: 8px;
    width: 20%;
  }

  .zip-input {
    width: 100%;
    border: 1px solid $color-input-border;
    margin-bottom: 1em;
    margin-right: 1em;
  }

  .box {
    border: 1px solid $color-border;
    border-radius: 8px;
    background-color: $color-background;
    padding: 10px 10px 10px 10px;
    width: 100%;
    margin-bottom: 10px;
    display: block !important;
  }

  .header {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  .zipbox {
    margin-bottom: 16px;
    display: flex;
    border: 0px;
    justify-content: space-between;
    border:0px;
  }

  .zip-to {
  }

  .zip-inputr {
    max-width: 200px;
    display: inline-block;
  }

  .zipr-box {
    padding-bottom: 10px;
    margin-top: 16px;
  }

  .h3-title {
    display: flex;
    margin-bottom: 2px;
  }

  .h3-icon {
    margin-right: 8px;
  }

  .zip-content-box {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
  }
  @media(max-width: 768px) {
    .zip-input-box {
      width: 50%;
    }
    .zip-to {
      display: block;
    }
  }
  .to {
    margin-left: 16px;
    margin-right: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/geo/MSCFCode.vue